import i18next, { addOptionsMessages, Namespace } from "../intl/i18next";
import { getOptions } from "../../options/options";
import { type Locale } from "../types/types";

import { programStore } from "./programStore";

/**
 * Override message copy for a locale for program previewing. Writes the store (react-intl path, merged on
 * render) and the i18next `options` namespace (i18next path); the store change re-renders both.
 */
export function setPreviewMessages(locale: Locale, messages: Record<string, unknown>): void {
  programStore.set((prev) => ({
    ...prev,
    overrides: {
      ...prev.overrides,
      messages: {
        ...prev.overrides.messages,
        [locale]: { ...prev.overrides.messages?.[locale], ...messages },
      },
    },
  }));

  addOptionsMessages({ [locale]: messages });
}

/**
 * Remove preview message overrides from the i18next `options` namespace. That namespace is shared with legacy `setOptions` messages, so we drop the whole per-locale bundle then re-apply the legacy messages from options.
 */
export function clearPreviewMessages(locales: Locale[]): void {
  locales.forEach((locale) => i18next.removeResourceBundle(locale, Namespace.OPTIONS));
  addOptionsMessages(getOptions().messagesWithLocale as Record<string, object>);
}
